<template>
	<vxe-modal v-model="modal" title="到货信息统计" width="1000" height="800" @show="show" show-footer :loading="loading">
		<template #default>
			<div>
				<el-calendar ref="payCalendar" v-model="date">
					<template slot="dateCell" slot-scope="{date, data}">
						<div>
							<div>
								<span>{{ data.day.split('-').slice(1).join('-') }}</span>
							</div>
							<div style="margin-top: 10px;" v-if="findorderBydate(data.day)">
								<el-tag effect="dark" style="margin: 2px 0;"
									size="mini">采单数量：{{findorderBydate(data.day).ordercount}}</el-tag>
								<el-tag effect="dark" type="danger" style="margin: 2px 0;"
									size="mini">总重量：{{findorderBydate(data.day).totalweight.toFixed(4)}}</el-tag>
							</div>
						</div>
					</template>
				</el-calendar>
<!-- 				<div class="flex" style="box-sizing: border-box;padding: 0px 20px;justify-content: flex-end;">
					<el-button size="mini" type="primary"
						style="margin-right: 20px;">总计：{{total.toFixed(2)}}</el-button>
					<el-button size="mini" type="primary"
						style="margin-right: 20px;">已提：{{unpay.toFixed(2)}}</el-button>
					<el-button size="mini" type="primary"
						style="margin-right: 20px;">未提：{{unpay.toFixed(2)}}</el-button>
				</div> -->
			</div>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			row: {
				default: () => {
					return null
				}
			},
			time: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				loading: false,
				modal: false,
				date: null,
				tabledata: [],
				sourcedata: [],
				total: 0,
				pay: 0,
				unpay: 0,
				audit: 0,
				auditdata: [],
				paydata: [],
				currenttime: 1
			}
		},
		watch: {
			date(v) {
				let timestamp = new Date(v).getTime()
				let res = this.findorderBydate(window.systemMethods.timestampToDate(timestamp, true))
				if (res) {
					this.showdetail(res)

				}
			},
			currenttime() {
				if (!this.loading) {
					this.init()
				}

			}
		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			showdetail(res) {
				this.$emit('showdetail', {
					data: res
				})
			},
			init() {
				this.loading = true
				this.$api.takegoods.getSummary({
					currenttime: parseInt(this.currenttime / 1000)
				}).then((res) => {
					this.sourcedata = JSON.parse(JSON.stringify(res))
					this.tabledata = this.$Lodash.groupBy(this.sourcedata, 'pregettime')
					// let unpaydata = res.filter((item) => {
					// 	return !item.ddcode
					// })
					// let auditdata = unpaydata.filter((item) => {
					// 	return item.submitstaffid
					// })
					// this.auditdata = auditdata
					// let tabledata = unpaydata.filter((item) => {
					// 	return !item.submitstaffid
					// })

					// let paydata = res.filter((item) => {
					// 	return item.ddcode
					// })
					// this.paydata = paydata
					// this.tabledata = this.$Lodash.groupBy(tabledata, 'prepaymentdate')

					// this.total = this.$Lodash.sumBy(this.sourcedata, item => parseFloat(item.needamount))
					// this.pay = this.$Lodash.sumBy(paydata, item => parseFloat(item.needamount))
					// this.unpay = this.$Lodash.sumBy(unpaydata, item => parseFloat(item.needamount))
					// this.audit = this.$Lodash.sumBy(auditdata, item => parseFloat(item.needamount))

					this.loading = false
				})
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {
				this.currenttime = this.$refs.payCalendar.date.getTime()
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			findorderBydate(date) {
				if (this.$refs.payCalendar) {
					this.currenttime = this.$refs.payCalendar.date.getTime()
				}
				if (this.tabledata[date]) {
					let billCodes = this.$Lodash.groupBy(this.tabledata[date],'billCode')
					billCodes = this.$Lodash.keys(billCodes)
					return {
						date: date,
						data: this.tabledata[date],
						totalweight: this.$Lodash.sumBy(this.tabledata[date], item =>
							parseFloat(item.totalweight)),
						totalnum: this.$Lodash.sumBy(this.tabledata[date], item =>
							parseFloat(item.num)),
						ordercount: billCodes.length
					}
				}
				return null
			}

		},
		components: {

		}
	}
</script>